/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_FeatureInputs */

const en_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature Request`)
};

const de_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionswunsch`)
};

const fr_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande de fonctionnalité`)
};

const es_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitud de función`)
};

const it_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiesta funzionalità`)
};

const nl_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functieverzoek`)
};

const pl_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prośba o funkcję`)
};

const fi_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuustoive`)
};

const da_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionsønske`)
};

const sv_feedback_category_feature = /** @type {(inputs: Feedback_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionsönskemål`)
};

/**
* | output |
* | --- |
* | "Feature Request" |
*
* @param {Feedback_Category_FeatureInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_category_feature = /** @type {((inputs?: Feedback_Category_FeatureInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_FeatureInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_category_feature(inputs)
	if (locale === "fr") return fr_feedback_category_feature(inputs)
	if (locale === "es") return es_feedback_category_feature(inputs)
	if (locale === "it") return it_feedback_category_feature(inputs)
	if (locale === "nl") return nl_feedback_category_feature(inputs)
	if (locale === "pl") return pl_feedback_category_feature(inputs)
	if (locale === "fi") return fi_feedback_category_feature(inputs)
	if (locale === "da") return da_feedback_category_feature(inputs)
	if (locale === "sv") return sv_feedback_category_feature(inputs)
	return en_feedback_category_feature(inputs)
});